export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * Implement the DateTime<Utc> scalar
   *
   * The input/output is a string in RFC3339 format.
   */
  DateTime: any;
};

export enum ActorType {
  Administrator = 'ADMINISTRATOR',
  User = 'USER'
}

export type Administrator = {
  __typename?: 'Administrator';
  id: Scalars['String'];
  name: Scalars['String'];
  oidcSub: Scalars['String'];
};

export type AppConfig = {
  __typename?: 'AppConfig';
  routeChangeAlert: Scalars['Boolean'];
  updatedAt: Scalars['String'];
};

export type AssetSource = {
  __typename?: 'AssetSource';
  id: Scalars['String'];
  source: Array<Scalars['Int']>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type CoordinateInput = {
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type CopyCourseInput = {
  newCourseName: Scalars['String'];
  sourceCourseId: Scalars['String'];
};

export type Course = {
  __typename?: 'Course';
  assetId: Scalars['Int'];
  assetVersion: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  isVisibleToAllUserGroups: Scalars['Boolean'];
  name: Scalars['String'];
  routeChangeAlert?: Maybe<RouteChangeAlert>;
  spots: Array<Spot>;
  updatedActorId: Scalars['String'];
  updatedActorType: ActorType;
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
  userGroup: UserGroup;
  userGroupId: Scalars['String'];
};

export enum CourseAssetType {
  Course = 'COURSE',
  Half = 'HALF',
  Logo = 'LOGO',
  Nomap = 'NOMAP',
  Start = 'START',
  Thumb = 'THUMB'
}

export type CreateAdministratorInput = {
  name: Scalars['String'];
};

export type CreateAdministratorPayload = {
  __typename?: 'CreateAdministratorPayload';
  administrator?: Maybe<Administrator>;
  error?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};

export type CreateCourseInput = {
  name: Scalars['String'];
};

export type CreateHyperlapseCoordinate = {
  __typename?: 'CreateHyperlapseCoordinate';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type CreateTrialDriveInput = {
  name: Scalars['String'];
};

export type CreateUserGroupInput = {
  name: Scalars['String'];
};

export type CreateUserInput = {
  name: Scalars['String'];
};

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  error?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type CreateUserWithUserGroupIdInput = {
  name: Scalars['String'];
  userGroupId: Scalars['String'];
};

export type CreateUserWithUserGroupPayload = {
  __typename?: 'CreateUserWithUserGroupPayload';
  error?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type DeleteCourseChangeAlertInput = {
  courseId: Scalars['String'];
};

export type DeleteCourseInput = {
  id: Scalars['String'];
};

export type DurationDistance = {
  __typename?: 'DurationDistance';
  distance: Scalars['Float'];
  duration: Scalars['Float'];
};

export type ExportCsv = {
  __typename?: 'ExportCsv';
  courseId: Scalars['String'];
  csvText: Scalars['String'];
};

export type ExportCsvPayload = {
  __typename?: 'ExportCsvPayload';
  error?: Maybe<Scalars['String']>;
  exportValue?: Maybe<ExportCsv>;
};

export type GenerateHyperlapseInput = {
  courseId: Scalars['String'];
  destination: CoordinateInput;
  origin: CoordinateInput;
  waypoints: Array<CoordinateInput>;
};

export type Hyperlapse = {
  __typename?: 'Hyperlapse';
  courseId: Scalars['String'];
  endCoordinate: Coordinate;
  id: Scalars['String'];
  imageInfomations?: Maybe<Array<OneFigPath>>;
  startCoordinate: Coordinate;
  waypointCoordinates?: Maybe<Array<Coordinate>>;
};

export type HyperlapseLatestInCoursePayload = {
  __typename?: 'HyperlapseLatestInCoursePayload';
  error?: Maybe<Scalars['String']>;
  hyperlapse?: Maybe<Hyperlapse>;
};

export type HyperlapsesFindByCourseIdPayload = {
  __typename?: 'HyperlapsesFindByCourseIdPayload';
  error?: Maybe<Scalars['String']>;
  hyperlapses?: Maybe<Array<Hyperlapse>>;
};

export type IdTokenPayload = {
  __typename?: 'IdTokenPayload';
  jwtToken: Scalars['String'];
};

export type ImageInput = {
  /** image データ。base64 エンコードされた文字列。 初登録の場合のみ存在。 */
  imageBytes?: InputMaybe<Scalars['String']>;
  /** この mutation よって初めて登録される写真か否か。 */
  isNewImage: Scalars['Boolean'];
  /** s3 にアップロードされた画像のパス。 既に登録済みの場合のみ存在。 */
  s3FilePath?: InputMaybe<Scalars['String']>;
};

export type InsertAfterSpotInput = {
  coordinate: CoordinateInput;
  courseId: Scalars['String'];
  spotType: SpotType;
  targetSpotId: Scalars['String'];
};

export type InsertDestInput = {
  coordinate: CoordinateInput;
  courseId: Scalars['String'];
};

export enum InsertMidSpotDirection {
  DownSide = 'DOWN_SIDE',
  DownSideSpecialProcessing = 'DOWN_SIDE_SPECIAL_PROCESSING',
  UpSide = 'UP_SIDE'
}

export type InsertMidSpotInput = {
  courseId: Scalars['String'];
  direction: InsertMidSpotDirection;
  parentSpotId?: InputMaybe<Scalars['String']>;
  spotType: SpotType;
  targetSpotId: Scalars['String'];
};

export type InsertPassingPointsInput = {
  passingPoints: Array<PassingPointInput>;
  trialDriveId: Scalars['String'];
};

export type InsertSpotFailure = {
  __typename?: 'InsertSpotFailure';
  message: Scalars['String'];
};

export type InsertSpotResult = InsertSpotFailure | InsertSpotSuccess;

export type InsertSpotSuccess = {
  __typename?: 'InsertSpotSuccess';
  spot: Spot;
};

export type InsertStartInput = {
  coordinate: CoordinateInput;
  courseId: Scalars['String'];
};

export type InsertTrialDriveSpotInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  trialDriveId: Scalars['String'];
};

export type MutationRoot = {
  __typename?: 'MutationRoot';
  copyCourse: Course;
  createAdministrator: CreateAdministratorPayload;
  createCourse: Course;
  createTrialDrive: TrialDrive;
  createUser: CreateUserPayload;
  createUserGroup: UserGroup;
  createUserWithUserGroupId: CreateUserWithUserGroupPayload;
  deleteCourse: Course;
  deleteCourseChangeAlert: Array<RouteChangeAlert>;
  generateHyperlapse: Hyperlapse;
  insertAfterSpot: InsertSpotResult;
  insertDest: Spot;
  insertMidSpot: InsertSpotResult;
  insertPassingPoints: Array<TrialDrivePassingPoint>;
  insertStart: Spot;
  insertTrialDriveSpot: TrialDriveSpot;
  removeAdministrator: RemoveAdministratorPayload;
  removeCourseAsset: AssetSource;
  removeMultipleSpots: Array<Spot>;
  removeSpot: Spot;
  removeSpotAsset: AssetSource;
  removeTrialDriveSpot: TrialDriveSpot;
  removeUser: RemoveUserPayload;
  reorderNarrationSpot: Scalars['Boolean'];
  updateCourse: Course;
  updateCourseAsset: AssetSource;
  updateCourseAssetId: Course;
  updateSpot: Spot;
  updateSpotAsset: AssetSource;
  updateSpotAssetId: Spot;
  updateThumbnail: Scalars['String'];
  updateTrialDriveSpot: TrialDriveSpot;
  uploadAsset: Course;
};


export type MutationRootCopyCourseArgs = {
  input: CopyCourseInput;
};


export type MutationRootCreateAdministratorArgs = {
  input: CreateAdministratorInput;
};


export type MutationRootCreateCourseArgs = {
  input: CreateCourseInput;
};


export type MutationRootCreateTrialDriveArgs = {
  input: CreateTrialDriveInput;
};


export type MutationRootCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationRootCreateUserGroupArgs = {
  input: CreateUserGroupInput;
};


export type MutationRootCreateUserWithUserGroupIdArgs = {
  input: CreateUserWithUserGroupIdInput;
};


export type MutationRootDeleteCourseArgs = {
  input: DeleteCourseInput;
};


export type MutationRootDeleteCourseChangeAlertArgs = {
  input: DeleteCourseChangeAlertInput;
};


export type MutationRootGenerateHyperlapseArgs = {
  input: GenerateHyperlapseInput;
};


export type MutationRootInsertAfterSpotArgs = {
  input: InsertAfterSpotInput;
};


export type MutationRootInsertDestArgs = {
  input: InsertDestInput;
};


export type MutationRootInsertMidSpotArgs = {
  input: InsertMidSpotInput;
};


export type MutationRootInsertPassingPointsArgs = {
  input: InsertPassingPointsInput;
};


export type MutationRootInsertStartArgs = {
  input: InsertStartInput;
};


export type MutationRootInsertTrialDriveSpotArgs = {
  input: InsertTrialDriveSpotInput;
};


export type MutationRootRemoveAdministratorArgs = {
  input: RemoveAdministratorInput;
};


export type MutationRootRemoveCourseAssetArgs = {
  input: RemoveCourseAssetInput;
};


export type MutationRootRemoveMultipleSpotsArgs = {
  input: RemoveMultipleSpotsInput;
};


export type MutationRootRemoveSpotArgs = {
  input: RemoveSpotInput;
};


export type MutationRootRemoveSpotAssetArgs = {
  input: RemoveSpotAssetInput;
};


export type MutationRootRemoveTrialDriveSpotArgs = {
  input: RemoveTrialDriveSpotInput;
};


export type MutationRootRemoveUserArgs = {
  input: RemoveUserInput;
};


export type MutationRootReorderNarrationSpotArgs = {
  input: ReorderNarrationSpotInput;
};


export type MutationRootUpdateCourseArgs = {
  input: UpdateCourseInput;
};


export type MutationRootUpdateCourseAssetArgs = {
  input: UpdateCourseAssetInput;
};


export type MutationRootUpdateCourseAssetIdArgs = {
  input: UpdateAssetIdInput;
};


export type MutationRootUpdateSpotArgs = {
  input: UpdateSpotInput;
};


export type MutationRootUpdateSpotAssetArgs = {
  input: UpdateSpotAssetInput;
};


export type MutationRootUpdateSpotAssetIdArgs = {
  input: UpdateAssetIdInput;
};


export type MutationRootUpdateThumbnailArgs = {
  input: UpdateThumbnailInput;
};


export type MutationRootUpdateTrialDriveSpotArgs = {
  input: UpdateTrialDriveSpotInput;
};


export type MutationRootUploadAssetArgs = {
  input: UploadAssetInput;
};

export type NavigationVoiceAndCoordinate = {
  __typename?: 'NavigationVoiceAndCoordinate';
  coordinate: Coordinate;
  navigationVoice: Scalars['String'];
};

export type OneFigPath = {
  __typename?: 'OneFigPath';
  fileName: Scalars['String'];
  heading: Scalars['Float'];
  index: Scalars['Int'];
  localIndex: Scalars['Int'];
  location: CreateHyperlapseCoordinate;
  success: Scalars['Boolean'];
};

export type PassingPointInput = {
  id: Scalars['String'];
  isContinuedFromPrevious: Scalars['Boolean'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  registeredAt: Scalars['DateTime'];
};

export type QueryRoot = {
  __typename?: 'QueryRoot';
  adminIdToken: IdTokenPayload;
  administrators: Array<Administrator>;
  allUserGroups: Array<UserGroup>;
  allUsers: Array<User>;
  appConfig: AppConfig;
  course: Course;
  courses: Array<Course>;
  coursesVisibleToAllUserGroups: Array<Course>;
  currentAdministrator?: Maybe<Administrator>;
  currentUser?: Maybe<User>;
  exportCsv: ExportCsvPayload;
  getCourseAsset: AssetSource;
  getSpotAsset: AssetSource;
  hyperlapses: HyperlapsesFindByCourseIdPayload;
  latestHyperlapse: HyperlapseLatestInCoursePayload;
  myUserGroup: UserGroup;
  routingInfomation: RoutingInfomationPayload;
  spot: Spot;
  textToSpeechEncodedAudio: TextToSpeechEncodedAudioPayload;
  trialDrive: TrialDrive;
  trialDriveSpot: TrialDriveSpot;
  trialDrives: Array<TrialDrive>;
  user: User;
  userGroup: UserGroup;
  userIdToken: IdTokenPayload;
};


export type QueryRootAdminIdTokenArgs = {
  code: Scalars['String'];
};


export type QueryRootCourseArgs = {
  id: Scalars['String'];
};


export type QueryRootExportCsvArgs = {
  courseId: Scalars['String'];
};


export type QueryRootGetCourseAssetArgs = {
  assetType: CourseAssetType;
  courseId: Scalars['String'];
};


export type QueryRootGetSpotAssetArgs = {
  assetType: SpotAssetType;
  spotId: Scalars['String'];
};


export type QueryRootHyperlapsesArgs = {
  courseId: Scalars['String'];
};


export type QueryRootLatestHyperlapseArgs = {
  courseId: Scalars['String'];
};


export type QueryRootRoutingInfomationArgs = {
  courseId: Scalars['String'];
};


export type QueryRootSpotArgs = {
  id: Scalars['String'];
};


export type QueryRootTextToSpeechEncodedAudioArgs = {
  inputText: Scalars['String'];
};


export type QueryRootTrialDriveArgs = {
  trialDriveId: Scalars['String'];
};


export type QueryRootTrialDriveSpotArgs = {
  trialDriveSpotId: Scalars['String'];
};


export type QueryRootTrialDrivesArgs = {
  userGroupId: Scalars['String'];
};


export type QueryRootUserArgs = {
  id: Scalars['String'];
};


export type QueryRootUserGroupArgs = {
  userGroupId: Scalars['String'];
};


export type QueryRootUserIdTokenArgs = {
  code: Scalars['String'];
};

export type RemoveAdministratorInput = {
  id: Scalars['String'];
};

export type RemoveAdministratorPayload = {
  __typename?: 'RemoveAdministratorPayload';
  administrator?: Maybe<Administrator>;
  error?: Maybe<Scalars['String']>;
};

export type RemoveCourseAssetInput = {
  assetType: CourseAssetType;
  id: Scalars['String'];
};

export type RemoveMultipleSpotsInput = {
  courseId: Scalars['String'];
  parentSpotId: Scalars['String'];
};

export type RemoveSpotAssetInput = {
  assetType: SpotAssetType;
  id: Scalars['String'];
};

export type RemoveSpotInput = {
  id: Scalars['String'];
};

export type RemoveTrialDriveSpotInput = {
  trialDriveSpotId: Scalars['String'];
};

export type RemoveUserInput = {
  id: Scalars['String'];
};

export type RemoveUserPayload = {
  __typename?: 'RemoveUserPayload';
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export enum ReorderNarrationSpotDirection {
  Down = 'DOWN',
  Up = 'UP'
}

export type ReorderNarrationSpotInput = {
  courseId: Scalars['String'];
  direction: ReorderNarrationSpotDirection;
  spotId: Scalars['String'];
};

export type RouteChangeAlert = {
  __typename?: 'RouteChangeAlert';
  archiveFilePath: Scalars['String'];
  courseId: Scalars['String'];
  createdAt: Scalars['String'];
  route: Array<Coordinate>;
};

export type RoutingInfomation = {
  __typename?: 'RoutingInfomation';
  from: Coordinate;
  navigation: Array<NavigationVoiceAndCoordinate>;
  route: Array<Coordinate>;
  spotStat: Array<SpotStat>;
  to: Coordinate;
};

export type RoutingInfomationPayload = {
  __typename?: 'RoutingInfomationPayload';
  error?: Maybe<Scalars['String']>;
  routingInfomation?: Maybe<RoutingInfomation>;
  routingInfomationWithoutOpt?: Maybe<RoutingInfomation>;
};

export type Spot = {
  __typename?: 'Spot';
  assetId: Scalars['Int'];
  coordinate: Coordinate;
  courseId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  geofenceRadius: Scalars['Int'];
  hasCafe: Scalars['Boolean'];
  hasEvCharger: Scalars['Boolean'];
  hasFreeParking: Scalars['Boolean'];
  hasMusic: Scalars['Boolean'];
  hasPaidParking: Scalars['Boolean'];
  hasRestaurant: Scalars['Boolean'];
  hasRestroom: Scalars['Boolean'];
  id: Scalars['String'];
  musicQuestion?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  narrationText?: Maybe<Scalars['String']>;
  narrationTextForTtsAfterMusic?: Maybe<Scalars['String']>;
  narrationTextForTtsBeforeMusic?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  parentSpotId?: Maybe<Scalars['String']>;
  spotCode?: Maybe<Scalars['Int']>;
  spotType: SpotType;
};

export enum SpotAssetType {
  Balloon = 'BALLOON',
  Detail = 'DETAIL',
  Thumb = 'THUMB'
}

export type SpotStat = {
  __typename?: 'SpotStat';
  durationDistance: DurationDistance;
  statsAfterSpotId: Scalars['String'];
};

export enum SpotType {
  Destination = 'DESTINATION',
  Narration = 'NARRATION',
  OptionalWaypoint = 'OPTIONAL_WAYPOINT',
  RoutingGuide = 'ROUTING_GUIDE',
  Start = 'START',
  SubaruMoment = 'SUBARU_MOMENT',
  Waypoint = 'WAYPOINT'
}

export type TextToSpeechEncodedAudioPayload = {
  __typename?: 'TextToSpeechEncodedAudioPayload';
  encodedAudio: Scalars['String'];
};

export type TrialDrive = {
  __typename?: 'TrialDrive';
  createdAt: Scalars['String'];
  name: Scalars['String'];
  passingPointSegments: Array<Array<TrialDrivePassingPoint>>;
  spots: Array<TrialDriveSpot>;
  trialDriveId: Scalars['String'];
  userGroupId: Scalars['String'];
  userId: Scalars['String'];
};

export type TrialDrivePassingPoint = {
  __typename?: 'TrialDrivePassingPoint';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  order: Scalars['Int'];
  trialDriveId: Scalars['String'];
  trialDrivePassingPointId: Scalars['String'];
};

export type TrialDriveSpot = {
  __typename?: 'TrialDriveSpot';
  hasCafe: Scalars['Boolean'];
  hasFreeParking: Scalars['Boolean'];
  hasPaidParking: Scalars['Boolean'];
  hasRestaurant: Scalars['Boolean'];
  hasRestroom: Scalars['Boolean'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  memo: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Int'];
  trialDriveId: Scalars['String'];
  trialDriveSpotId: Scalars['String'];
  trialDriveSpotPhotos: Array<TrialDriveSpotPhoto>;
};

export type TrialDriveSpotPhoto = {
  __typename?: 'TrialDriveSpotPhoto';
  trialDriveSpotId: Scalars['String'];
  trialDriveSpotPhotoId: Scalars['String'];
  url: Scalars['String'];
};

export type UpdateAssetIdInput = {
  assetId: Scalars['Int'];
  id: Scalars['String'];
};

export type UpdateCourseAssetInput = {
  assetType: CourseAssetType;
  id: Scalars['String'];
  source: Array<Scalars['Int']>;
};

export type UpdateCourseInput = {
  id: Scalars['String'];
  isVisibleToAllUserGroups?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSpotAssetInput = {
  assetType: SpotAssetType;
  id: Scalars['String'];
  source: Array<Scalars['Int']>;
};

export type UpdateSpotInput = {
  coordinate?: InputMaybe<CoordinateInput>;
  description?: InputMaybe<Scalars['String']>;
  geofenceRaduis?: InputMaybe<Scalars['Int']>;
  hasCafe?: InputMaybe<Scalars['Boolean']>;
  hasEvCharger?: InputMaybe<Scalars['Boolean']>;
  hasFreeParking?: InputMaybe<Scalars['Boolean']>;
  hasPaidParking?: InputMaybe<Scalars['Boolean']>;
  hasRestaurant?: InputMaybe<Scalars['Boolean']>;
  hasRestroom?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  musicQuestion?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  narrationText?: InputMaybe<Scalars['String']>;
  narrationTextForTtsAfterMusic?: InputMaybe<Scalars['String']>;
  narrationTextForTtsBeforeMusic?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  parentSpotId?: InputMaybe<Scalars['String']>;
  spotCode?: InputMaybe<Scalars['Int']>;
  spotType?: InputMaybe<SpotType>;
};

export type UpdateThumbnailInput = {
  courseId: Scalars['String'];
};

export type UpdateTrialDriveSpotInput = {
  hasCafe: Scalars['Boolean'];
  hasFreeParking: Scalars['Boolean'];
  hasPaidParking: Scalars['Boolean'];
  hasRestaurant: Scalars['Boolean'];
  hasRestroom: Scalars['Boolean'];
  images: Array<ImageInput>;
  memo: Scalars['String'];
  name: Scalars['String'];
  trialDriveSpotId: Scalars['String'];
  updateImages: Scalars['Boolean'];
};

export type UploadAssetInput = {
  assetVersion: Scalars['String'];
  id: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['String'];
  name: Scalars['String'];
  oidcSub: Scalars['String'];
  userGroup: UserGroup;
  userGroupId: Scalars['String'];
};

export type UserGroup = {
  __typename?: 'UserGroup';
  courses: Array<Course>;
  id: Scalars['String'];
  name: Scalars['String'];
  users: Array<User>;
};
